if ($(window).width() >= 992) {
    function Player() {

        this.tracks = null;

        this.play = function(track) {
            $('audio').append('<source src="" type="audio/mpeg">');
            $('audio').attr('src', track);
            $('audio')[0].play();
        }

        this.stop = function() {
            $('audio')[0].pause();
            $('audio')[0].currentTime = 0.0;
        }

        this.next = function() {

            var current = $('audio').attr('src');

            var i = $.inArray(current, this.tracks);

            i++;

            if (i == this.tracks.length - 1) {
                $('.player-controls .next-track').addClass('disabled');
            }

            if (i > 0) {
                $('.player-controls .prev-track').removeClass('disabled');
            }else {
                $('.player-controls .prev-track').addClass('disabled');
            }

            $('.player-controls .play-track').removeClass('play-track').addClass('pause-track');

            $('.player-sample').text('Sample ' + (i+1) + ' of ' + this.tracks.length );

            this.play(player.tracks[i]);

        }

        this.prev = function() {

            var current = $('audio').attr('src');

            var i = $.inArray(current, this.tracks);

            i--;

            if (i == 0) {
                $('.player-controls .prev-track').addClass('disabled');
            }

            if (i < this.tracks.length - 1) {
                $('.player-controls .next-track').removeClass('disabled');
            }else {
                $('.player-controls .next-track').addClass('disabled');
            }

            $('.player-controls .play-track').removeClass('play-track').addClass('pause-track');

            $('.player-sample').text('Sample ' + (i+1) + ' of ' + this.tracks.length );

            this.play(player.tracks[i]);

        }

        this.playerInit = function() {

            var volume = $('.player-volume').slider('value');
            $('audio')[0].volume = volume / 100;

            $('.player-controls a').addClass('disabled');

            if (this.tracks.length > 1) {
                $('.player-controls a.disabled').not('.prev-track').removeClass('disabled');
            }else {
                $('.player-controls a.disabled').not('.prev-track, .next-track').removeClass('disabled');
            }

            $('.player-controls a.play-track').addClass('pause-track').removeClass('play-track');

            $('audio')[0].onloadeddata = function(){

                dur = $('audio')[0].duration.toFixed(2);

                durMin = Math.floor(dur / 60);
                durSec = Math.ceil(dur % 60);

                if(durMin < 10) durMin = '0' + durMin;
                if(durSec < 10) durSec = '0' + durSec;

                $('.player-time .full-time').text( durMin + ' : ' + durSec );

            }

            $('audio')[0].ontimeupdate = function() {
                dur = $('audio')[0].duration.toFixed(2);
                var curtime = $('audio')[0].currentTime.toFixed(2);

                durMin = Math.floor(curtime / 60);
                durSec = Math.ceil(curtime % 60);

                if(durMin < 10) durMin = '0' + durMin;
                if(durSec < 10) durSec = '0' + durSec;

                $('.player-time .cur-time').text( durMin + ' : ' + durSec );

                if($('audio')[0].ended) {
                    $('.player-controls a.pause-track').addClass('play-track').removeClass('pause-track');
                    $('.player-stop').removeClass('player-stop').addClass('player-play'); 
                    player.stop();
                }

                var res_time = 100 / dur * curtime ;

                progress.slider('value', res_time);

                $( ".player-progress" ).on( "slide", function( event, ui ) {
                    $('audio')[0].currentTime = (dur / 100) * ui.value ;
                } );

            }

        }

    }

    var progress = $(".player-progress").slider({
        range: "min",
        min: 0,
        max: 100,

    });

    var volume = $(".player-volume").slider({
        range: "min",
        min: 0,
        max: 100,
        value: 50,

    });

    var player = new Player();

    $( ".player-volume" ).on( "slide", function( event, ui ) {
        $('audio')[0].volume = ui.value / 100 ;
    } );

    $('.content-body').on('click', '.player-play', function(e) {

        e.preventDefault();

        $('.player-stop').removeClass('player-stop').addClass('player-play');
        $(this).removeClass('player-play').addClass('player-stop');

        $('.player-play').removeClass('last-played');
        $(this).addClass('last-played');

        $('.content-row').removeClass('current');
        $('.content-row[data-id="'+$(this).attr('data-id')+'"]').addClass('current');

        player.tracks = new Array();

        var tracks = $(this).next('.data-tracks').find('span');

        tracks.each(function(){
            player.tracks.push($(this).attr('data-track'));
        });

        player.playerInit();

        player.play(player.tracks[0]);

        var current = $('audio').attr('src');

        var i = $.inArray(current, player.tracks);

        $('.player-sample').text('Sample ' + (i+1) + ' of ' + player.tracks.length );

        $('.player-author').text($(this).attr('data-author'));

        $('.player-track').html($(this).attr('data-track'));


        return false;

    });

    $('.content-body').on('click', '.player-stop', function(e) {

        e.preventDefault();

        $(this).removeClass('player-stop').addClass('player-play');

        $('.player-controls a.pause-track').addClass('play-track').removeClass('pause-track');

        player.stop();

        return false;

    });

    $('.player-controls').on('click', 'a.play-track', function(e) {

        e.preventDefault();

        $('audio')[0].play();

        $(this).addClass('pause-track').removeClass('play-track');
        $('.last-played').addClass('player-stop');

        return false;
    });

    $('.player-controls').on('click', 'a.pause-track', function(e) {

        e.preventDefault();

        $('audio')[0].pause();

        $(this).addClass('play-track').removeClass('pause-track');

        return false;
    });

    $('.player-controls').on('click', 'a.next-track', function(e) {

        e.preventDefault();

        player.next();

        return false;
    });

    $('.player-controls').on('click', 'a.prev-track', function(e) {

        e.preventDefault();

        player.prev();

        return false;
    });
} else {

    function Player() {

        this.tracks = null;

        this.play = function(track) {
            $('audio').append('<source src="" type="audio/mpeg">');
            $('audio').attr('src',track);
            $('audio')[0].play();
        }

        this.stop = function() {
            $('audio')[0].pause();
            $('audio')[0].currentTime = 0.0;
        }

        this.next = function() {

            var current = $('audio').attr('src');

            var i = $.inArray(current, this.tracks);

            i++;

            $('a.play-list__pause').addClass('play-list__play').removeClass('play-list__pause');

            $('.player-controls .play-track').removeClass('play-track').addClass('pause-track');

            this.play(player.tracks[i]);

            $('a.play-data[data-track="'+$('audio').attr('src')+'"]').addClass('play-list__pause').removeClass('play-list__play');

        }

        this.prev = function() {

            var current = $('audio').attr('src');

            var i = $.inArray(current, this.tracks);

            i--;

            $('a.play-list__pause').addClass('play-list__play').removeClass('play-list__pause');

            $('.player-controls .play-track').removeClass('play-track').addClass('pause-track');

            this.play(player.tracks[i]);

            $('a.play-data[data-track="'+$('audio').attr('src')+'"]').addClass('play-list__pause').removeClass('play-list__play');

        }

        this.playerInit = function() {

            player.tracks = new Array();

            var tracks = $('.play-data');

            tracks.each(function(){
                player.tracks.push($(this).attr('data-track'));
            });

            $('.player__mobile').animate({
                'bottom': 0
            }); 

            $('.player-controls a.play-list__play').addClass('play-list__pause').removeClass('play-list__play');

            
            $('audio')[0].ontimeupdate = function() {
                dur = $('audio')[0].duration.toFixed(2);
                var curtime = $('audio')[0].currentTime.toFixed(2);

                if($('audio')[0].ended) {
                    $('.player-controls a.play-list__pause').addClass('play-list__play').removeClass('play-list__pause');
                    $('.play-list__pause').addClass('play-list__play').removeClass('play-list__pause');
                    player.stop();
                }

                var res_time = 100 / dur * curtime ;

                progress.slider('value', res_time);

                $( ".player-progress" ).on( "slide", function( event, ui ) {
                    $('audio')[0].currentTime = (dur / 100) * ui.value ;
                } );

            }

        }

    }

    var progress = $(".player-progress").slider({
        range: "min",
        min: 0,
        max: 100,

    });

    var player = new Player();

    $('.voicelibrary__mobile').on('click', '.play-list__play', function(e) {

        e.preventDefault();

        if ($(this).data('track') != $('audio').attr('src')) {
            player.playerInit();
            player.play($(this).data('track'));
            
            $('a.play-list__pause').addClass('play-list__play').removeClass('play-list__pause');
            $(this).addClass('play-list__pause').removeClass('play-list__play');
            $('.player-controls a.play-track').addClass('pause-track').removeClass('play-track');

            $('.player-author').text($(this).data('author'));
            $('.player-track').text($(this).data('category'));

        } else {
            $('audio')[0].play();
            $(this).addClass('play-list__pause').removeClass('play-list__play');
            $('.player-controls a.play-track').addClass('pause-track').removeClass('play-track');
            
        }
        
        return false;

    });

    $('.voicelibrary__mobile').on('click', '.play-list__pause', function(e) {

        e.preventDefault();

        $('audio')[0].pause();

        $('a.play-list__pause').addClass('play-list__play').removeClass('play-list__pause');
        $('.player-controls a.pause-track').addClass('play-track').removeClass('pause-track');
        return false;

    });


    $('.player-controls').on('click', '.play-track', function(e) {

        e.preventDefault();

        $('audio')[0].play();
        $('.play-list__mobile a[data-track="'+$('audio').attr('src')+'"]').addClass('play-list__pause').removeClass('play-list__play');
        $(this).addClass('pause-track').removeClass('play-track');
        
        return false;

    });

    $('.player-controls').on('click', '.pause-track', function(e) {

        e.preventDefault();

        $('audio')[0].pause();
        $('.play-list__mobile a[data-track="'+$('audio').attr('src')+'"]').addClass('play-list__play').removeClass('play-list__pause');
        $(this).addClass('play-track').removeClass('pause-track');

        return false;

    });

    $('.player-controls').on('click', 'a.next-track', function(e) {

        e.preventDefault();

        player.next();

        $('.player-author').text($('.play-list__pause').data('author'));
        $('.player-track').text($('.play-list__pause').data('category'));

        return false;
    });

    $('.player-controls').on('click', 'a.prev-track', function(e) {

        e.preventDefault();

        player.prev();

        return false;
    });

}













